import { z } from 'zod';
import { DeviceType, deviceTypeSchema } from 'app/agriculture/queries/devices/types/DeviceType';
import { MapLocation, mapLocationSchema } from 'app/agriculture/queries/types/MapLocation';
import { Brand, brandSchema } from 'app/agriculture/queries/devices/types/Brand';

export interface Device {
    id: string;

    farmId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    brand: Brand;
    deviceType: DeviceType;
    locationOverride?: MapLocation | null;
    externalId: string;

    infrastructureId: string | null;

    tankMaxVolume: number | null;
    tankMaxHeight: number | null;
    tankCalibrationOffset: number | null;
}

export const deviceSchema = z.object({
    id: z.string().uuid(),

    farmId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    brand: brandSchema,
    deviceType: deviceTypeSchema,
    locationOverride: mapLocationSchema.optional().nullable(),
    externalId: z.string(),

    infrastructureId: z.string().uuid().nullable(),

    tankMaxVolume: z.number().nullable(),
    tankMaxHeight: z.number().nullable(),
    tankCalibrationOffset: z.number().nullable(),
});

export const mockDevice = ({
    id = 'fd570416-e806-4a22-8783-9789e060dea3',

    farmId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock device',
    brand = 'Yarn',
    deviceType = 'Yarn Gateway',
    locationOverride,
    externalId = 'mock-external-id',

    infrastructureId = null,

    tankMaxVolume = null,
    tankMaxHeight = null,
    tankCalibrationOffset = null,
}: Partial<Device> = {}): Device => ({
    id,

    farmId,
    createdAt,
    updatedAt,

    name,
    brand,
    deviceType,
    locationOverride,
    externalId,

    infrastructureId,

    tankMaxVolume,
    tankMaxHeight,
    tankCalibrationOffset,
});
